import apiV2 from "api-v2";

import type {
	SupplierListsPagedParams,
	SupplierListsPagedResponse,
} from "../types/supplier-list.types";

/**
 * Fetch a single tab's page of supplier lists (PRO-628).
 *
 * Backed by `GET supplier/paged-index`, which paginates + searches + filters +
 * sorts at the DB level. This is a NEW endpoint used only by the paged screen —
 * the legacy all-tabs `getSupplierLists` call is untouched and still used
 * elsewhere.
 */
export const getSupplierListsPaged = async (
	params: SupplierListsPagedParams
): Promise<SupplierListsPagedResponse> => {
	const { tab, page, limit, search, sort, filters, excludeProjectId } = params;

	const query: Record<string, unknown> = { tab, page, limit, sort };

	if (search) {
		query.search = search;
	}

	// The backend `scopeFiltering` reads `filters[start_date]` / `filters[end_date]`.
	if (filters && (filters.start_date || filters.end_date)) {
		query.filters = filters;
	}

	// Exclude lists already attached to a project (drawer "add" mode).
	if (excludeProjectId !== null && excludeProjectId !== undefined) {
		query.exclude_project_id = excludeProjectId;
	}

	const { data } = await apiV2.get("supplier/paged-index", { params: query });

	return data as SupplierListsPagedResponse;
};
